<template>
  <h3 class="thin">
    <router-link v-if="right" :to="{ name: route }" v-bind="$attrs" class="btn btn-white">
      <!-- #I8 / #I9 -->
      <span :aria-label="$t('common.search')" role="img">
        <VSvgIcon name="search" variant="outlined" size="middle" />
      </span>
      <slot />
    </router-link>
    <template v-else>
      <slot />
    </template>
  </h3>
</template>

<script>
import VSvgIcon from '@/components/UI/VSvgIcon.vue';
export default {
  name: 'DashboardTitle',

  components: {
    VSvgIcon,
  },

  inheritAttrs: false,

  props: {
    right: {
      required: true,
      type: Boolean,
    },

    route: {
      required: true,
      type: String,
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@scss';

h3 {
  padding: 4px 0 2px;
  margin: 0;

  @media screen and (min-width: 461px) {
    .collapsed & {
      float: left;
      margin-right: $building-unit;
    }
  }
}

@media screen and (min-width: #{$grid-small-min}px) and (max-width: #{$grid-small-max}px) {
  h3 {
    min-width: 156px;

    .btn {
      width: 100%;
    }
  }
}

@media screen and (max-width: 460px) {
  h3 .btn {
    width: 100%;
  }
}
</style>
